
<div class="row">
    <div class="col-12">

        <!-- title -->
        <div class="title">
            <h5> Вы действительно хотите удалить выбранную роль? </h5>
        </div>

        <!-- content -->
        <div class="content">

            <!-- info -->
            <div class="info">
                <ul *ngFor="let data of roleData">
                    <li *ngIf="data.count != 0"> Роль <b>{{ data.name }}</b> назначена {{ data.count }} пользователю(ям) </li>
                </ul>
            </div>

        </div>

        <!-- buttons -->
        <div class="buttons">

            <!-- close -->
            <button type="button" class="btn btn-back btn-light" (click)="activeModal.dismiss(false)">
                Нет
            </button>

            <!-- delete -->
            <button type="button" class="btn btn-create btn-primary delete" (click)="delete()" [disabled]="count != 0">
                Да
            </button>

        </div>

    </div>
</div>

